import { useState } from "react";
import { useT } from "../lib/i18n";

/**
 * Interactive "use cases" section: a row of tabs, each showing a real
 * technical-call moment as a "they asked → say this" pair. Mirrors the
 * before/after framing of the in-meeting copilot, anchored to the ESL
 * English-call wedge (the question and the suggested answer stay in
 * English; the surrounding chrome is localized).
 */
export function UseCases() {
  const t = useT();
  const copy = t.useCases;
  const [active, setActive] = useState(0);
  const item = copy.items[active];

  return (
    <section id="use-cases" className="border-t border-margin dark:border-paper/10">
      <div className="mx-auto max-w-3xl px-6 py-24">
        <p className="text-xs font-medium uppercase tracking-wider text-ink/50 dark:text-paper/50">
          {copy.label}
        </p>
        <h2 className="mt-2 font-display text-3xl sm:text-4xl font-semibold tracking-tight text-ink dark:text-paper leading-tight">
          {copy.heading}
        </h2>
        <p className="mt-4 text-lg text-ink/70 dark:text-paper/70 leading-relaxed">
          {copy.subheading}
        </p>

        <div className="mt-10 flex flex-wrap gap-2" role="tablist">
          {copy.items.map((it, i) => (
            <button
              key={it.tab}
              type="button"
              role="tab"
              aria-selected={i === active}
              onClick={() => setActive(i)}
              className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                i === active
                  ? "bg-ink text-paper dark:bg-paper dark:text-ink"
                  : "border border-margin text-ink/60 hover:text-ink dark:border-paper/15 dark:text-paper/60 dark:hover:text-paper"
              }`}
            >
              {it.tab}
            </button>
          ))}
        </div>

        <div className="mt-8 rounded-2xl border border-margin p-6 sm:p-8 dark:border-paper/10">
          <p className="text-sm text-ink/60 dark:text-paper/60 leading-relaxed">
            {item.scenario}
          </p>

          <div className="mt-6">
            <p className="font-mono text-xs uppercase tracking-wider text-ink/50 dark:text-paper/50">
              {copy.saidLabel}
            </p>
            <p className="mt-2 text-lg text-ink/80 dark:text-paper/80 leading-relaxed">
              &ldquo;{item.said}&rdquo;
            </p>
          </div>

          <div className="mt-6 rounded-xl border border-rec/30 bg-rec/5 p-5">
            <p className="flex items-center gap-2 font-mono text-xs uppercase tracking-wider text-rec">
              <span className="h-1.5 w-1.5 rounded-full bg-rec" aria-hidden />
              {copy.sayLabel}
            </p>
            <p className="mt-2 text-lg leading-relaxed text-ink dark:text-paper">
              {item.say}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
